import { FC } from "react";
import { Formik, Form } from 'formik';
import { ButtonSubmit, FormInput } from "components";
import { ButtonGroup, VStack, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { validateUrl } from "lib/utils";
import { object, SchemaOf, string } from "yup";
import { DraftAsset } from "lib/types";
import { useCreateAsset } from "lib/hooks/useCreateAsset";

type Props = {
  onClose: () => void;
  asset: DraftAsset;
}

enum LinkFormFields {
  URL = 'url',
  TITLE = 'title',
}

type LinkSchema = {
  [LinkFormFields.URL]: string;
  [LinkFormFields.TITLE]: string;
}

const linkValidation: SchemaOf<LinkSchema>  = object().shape({
  [LinkFormFields.TITLE]: string(),
  [LinkFormFields.URL]: validateUrl,
});

export const DraftLinkForm: FC<Props> = ({ onClose, asset }) => {
  const { link } = useCreateAsset();

  const onSubmit = async (values): Promise<void> => {
    await link(values.url, values.title);
    onClose();
  }

  return (
    <Formik
      initialValues={{ url: asset?.value || '', title: asset?.value || '' }}
      validationSchema={linkValidation}
      onSubmit={onSubmit}
    >
      <Form>
        <ModalBody>
          <VStack spacing={5} width="100%">
            <FormInput name="title" label="Title" />
            <FormInput name="url" label="Website URL" isRequired autoFocus={true} />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup width="100%" justifyContent="end">
            <Button variant="cancel" onClick={onClose}>Cancel</Button>
            <ButtonSubmit>Save</ButtonSubmit>
          </ButtonGroup>
        </ModalFooter>
      </Form>
    </Formik>
  )
};
